import React, { useContext } from 'react'
import { Button, Typography } from 'antd'
import styled from 'styled-components'
import { FormattedMessage, injectIntl } from 'react-intl'

import Background from '../assets/Background'
import { AuthContext } from '../Components/Auth/AuthContext'
import { ThemeContext } from '../Theme/ThemeContext'
import { UserRole } from '../Components/User/types'

const Home: React.FC = () => {
  const { authUser } = useContext(AuthContext)
  const { isDarkMode } = useContext(ThemeContext)

  const renderWelcomeTextBasedOnRole = (role: UserRole): string => {
    switch (role.toLowerCase()) {
      case UserRole.ADMIN:
        return 'Instructing made easy.'
      case UserRole.CLIENT:
        return 'Schooling made easy.'
      default:
        return 'Instructing made easy.'
    }
  }

  return (
    <>
      <Background />
      <Container>
        <StyledTitle level={1} color='#17375f' isDarkMode={isDarkMode}>
          {renderWelcomeTextBasedOnRole(authUser.role)}
        </StyledTitle>
        <StyledSubtitle level={5}>
          <FormattedMessage description="course" id="generic.welcomeBack" values={{name: authUser.firstName }} />
        </StyledSubtitle>
      </Container>
    </>
  )
}

export default injectIntl(Home)

const Container = styled.div`
  position: absolute;
  top: 30%;
  left: 15%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const StyledTitle = styled(Typography.Title)<{isDarkMode: boolean}>`
  font-family: 'Roboto', sans-serif;
  color: ${({ color, isDarkMode }) => (isDarkMode ? 'white' : color) || 'inherit'} !important;
  margin-bottom: 0 !important;
`

const StyledSubtitle = styled(Typography.Title)`
  font-family: 'Roboto', sans-serif;
  margin-top: 0 !important;
`